import { cn } from '@/core/utils/common'

import type { ReactNode } from 'react'

type ContainerProps = {
  children: ReactNode
  className?: string
}

export default function Container({ children, className }: ContainerProps) {
  return (
    <div className="flex justify-center">
      <div className={cn('wrapper', className)}>{children}</div>
    </div>
  )
}
